<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 24a12.01 12.01 0 1 1 12-12c0 6.62-5.38 12-12 12m0-22a10.01 10.01 0 0 0 0 20 10.01 10.01 0 0 0 0-20m4 14h-5.46q.58-.48 1.64-1.07c1.7-.98 3.82-2.2 3.82-4.93a4 4 0 0 0-8 0h2a2 2 0 0 1 4 0c0 1.46-1.07 2.18-2.82 3.2C9.68 14.06 8 15.03 8 17v1h8z"/></svg>
</template>
